import React from "react";
// msal imports
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import LoginView from "./screens/login";
import AppRoutes from "./routes";
import "./App.css";

const App = ({ pca }) => {
  return (
    <MsalProvider instance={pca}>
      <div className="mainSize_1100 p_lr_10">
        <AuthenticatedTemplate>
          <AppRoutes />
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <LoginView />
        </UnauthenticatedTemplate>
      </div>
    </MsalProvider>
  );
};

export default App;
